import React from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { ExportProvider } from '../../contexts/ExportContext';
import { ExportToast } from '../Common/ExportToast';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflow: 'auto',
    backgroundColor: tokens.colorNeutralBackground3,
  },
});

export const AppShell: React.FC = () => {
  const styles = useStyles();

  return (
    <ExportProvider>
      <div className={styles.container}>
        <Sidebar />
        <div className={styles.main}>
          <TopBar />
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
      </div>
      <ExportToast />
    </ExportProvider>
  );
};

export default AppShell;
